import { useTranslation } from 'react-i18next';

import { DriveFolderUpload, VButton, VDialog, useFlag } from '@/package';

import { PathSelector } from '../../PathSelector';

const TaskCreateFormSelectPathButton = ({
  onSelect,
}: {
  onSelect: (param: { basePath: string; orgPath: string }) => void;
}) => {
  const {
    value: visibleModal,
    setTrue: openModal,
    setFalse: closeModal,
  } = useFlag(true);
  const { t } = useTranslation();

  return (
    <>
      <VButton size="md" onClick={openModal}>
        <DriveFolderUpload className="h-4 w-4" />
        <span className="text-nowrap">{t('task.selectFolder.ansulate')}</span>
      </VButton>

      <VDialog
        visible={visibleModal}
        onUpdateVisible={visible => (visible ? openModal() : closeModal())}
      >
        <PathSelector
          onSelect={param => {
            onSelect(param);
            closeModal();
          }}
        />
      </VDialog>
    </>
  );
};

export default TaskCreateFormSelectPathButton;
